import React, { useState, useRef, useEffect } from 'react';
import { EyeIcon, LinkIcon, MoreDotIcon, PencilIcon } from '../../assets/Icons';
import { API_ENDPOINTS, HUB_VIEW_ENDPOINTS } from '../../pages/utils/endpoints';
import { http_delete, http_get } from '../../pages/utils/api_client';

const Card = ({ item, baseUrl, companySlug, setUpdatedData }) => {
  const { name, material_type, status, description, slug, opens, unique_visits, completions } = item;
  const [visible, setVisible] = useState(false);
  const menuRef = useRef(null);
  const [copyVisible, setCopyVisible] = useState(false);

  const navPublishedView = () => {
    window.location.pathname = `${baseUrl}`;
  };

  const navEditView = () => {
    window.location.pathname = `${baseUrl}/edit`;
  };

  const toggleMenu = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLinkCopy = ({ iframe = false }) => {
    const link = `${window.location.origin}${HUB_VIEW_ENDPOINTS.VIEW_MATERIAL(companySlug, item.slug)}`;
    if (iframe) {
      const data = `<iframe src="${link}" height="400" width="100%" title="${name}" frameborder="0"></iframe>`;
      navigator.clipboard.writeText(data);
    } else {
      navigator.clipboard.writeText(link);
    }
    setVisible(false);

    setCopyVisible(true);
    setTimeout(() => {
      setCopyVisible(false);
    }, 2000);
  };

  const handleDelete = () => {
    if (confirm(`Are you sure you want to delete this material: ${name}?`)) {
      http_delete(API_ENDPOINTS.DELETE_MATERIAL(slug))
        .then((res) => {
          if (res && res.data && res.data.message) {
            alert(res.data.message);
            http_get(API_ENDPOINTS.GET_LEARNING_MATERIALS, { category: material_type === "Walkthrough" ? "walkthroughs" : material_type.toLowerCase() })
              .then((res) => {
                setUpdatedData(res.data);
              })
          }
          else {
            alert(res.data.error);
          }
        })
        .finally(() => { });
    }
  }

  const handleDuplicate = () => {
    http_get(API_ENDPOINTS.DUPLICATE_LEARNING_MATERIAL(slug))
      .then((res) => {
        if (res && res.data && res.data.message) {
          alert(res.data.message);
          http_get(API_ENDPOINTS.GET_LEARNING_MATERIALS, { category: material_type === "Walkthrough" ? "walkthroughs" : material_type.toLowerCase() })
            .then((res) => {
              setUpdatedData(res.data);
            })
        }
        else {
          alert(res.data.error);
        }
      })
      .catch((err) => {
        alert(err?.response?.data?.error || err?.response?.data?.message || 'Unable to duplicate material.');
      })
      .finally(() => { });
  }

  return (
    <div className="un-card">
      <div className="card-body">
        <div className="top-section">
          <div className={`state ${status.toLowerCase()}`}>
            <span></span>
            {status}
          </div>
          <div className="actions">
            <div onClick={navPublishedView} title="View">
              <EyeIcon />
            </div>
            <div onClick={navEditView} title="Edit">
              <PencilIcon />
            </div>
            <div onClick={handleLinkCopy} title="Copy link">
              <LinkIcon />
            </div>
            <div onClick={toggleMenu}>
              <MoreDotIcon />
            </div>
          </div>
          {copyVisible && <span className="copied-toast">Copied!</span>}
          {visible && (
            <div className="menu" ref={menuRef}>
              <div className="menu-item">
                <a href="#view" onClick={navPublishedView}>View the material</a>
              </div>
              <div className="menu-item">
                <a href="#edit" onClick={navEditView}>Edit the material</a>
              </div>
              <div className="menu-item">
                <a href="#publish">Publish the material</a>
              </div>
              <div className="menu-item">
                <a href="#copy-url" onClick={handleLinkCopy}>Copy URL</a>
              </div>
              <div className="menu-item" onClick={() => handleLinkCopy({ iframe: true })}>
                <a href="#copy-embed">Copy embed code</a>
              </div>
              <div className="menu-item" onClick={() => handleDuplicate()}>
                <a href="#duplicate">Duplicate the content</a>
              </div>
              <div className="menu-item" onClick={() => handleDelete()}>
                <a href="#delete">Delete the content</a>
              </div>
            </div>
          )}
        </div>
        <div className="title">
          <h3>{name}</h3>
          <p>{material_type}</p>
        </div>
        <div className="details">
          <p>
            {description || 'These meticulously crafted resources are designed to aid students, educators.'}
          </p>
        </div>
      </div>
      <div className="card-footer">
        <div>
          <p className="text">Opens</p>
          <p className="text blue">{opens}</p>
        </div>
        <div className="divider"></div>
        <div>
          <p className="text">Completions</p>
          <p className="text blue">{completions}</p>
        </div>
        <div className="divider"></div>
        <div>
          <p className="text">Uniques</p>
          <p className="text blue">{unique_visits}</p>
        </div>

      </div>
    </div>
  );
};

export default Card;
